import React from 'react';

export function GridOverlay({ className = '' }) {
  return (
    <div
      className={`pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:64px_64px] [mask-image:radial-gradient(ellipse_80%_70%_at_50%_40%,black,transparent)] ${className}`}
      aria-hidden
    />
  );
}

export function GradientOrbs({ className = '' }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
      <div className="absolute -top-32 -right-20 h-[420px] w-[420px] rounded-full bg-primary/20 blur-[100px]" />
      <div className="absolute bottom-0 left-[-10%] h-[360px] w-[360px] rounded-full bg-secondary/10 blur-[90px]" />
      <div className="absolute top-1/3 left-1/2 h-[280px] w-[280px] -translate-x-1/2 rounded-full bg-accent/5 blur-[80px]" />
    </div>
  );
}

export function FloatingShapes({ className = '' }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
      <svg className="absolute right-[8%] top-[18%] h-16 w-16 animate-float-slow text-primary/30" viewBox="0 0 64 64" fill="none">
        <rect x="8" y="8" width="48" height="48" rx="14" stroke="currentColor" strokeWidth="2" />
        <path d="M22 32l8 8 16-16" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <svg className="absolute left-[6%] top-[42%] h-14 w-14 animate-float-slow text-secondary/25 [animation-delay:1s]" viewBox="0 0 56 56" fill="none">
        <path d="M28 8l4 12h12l-10 8 4 12-10-8-10 8 4-12-10-8h12z" stroke="currentColor" strokeWidth="1.5" />
      </svg>
      <svg className="absolute right-[18%] bottom-[22%] h-20 w-20 animate-float-slow text-accent/20 [animation-delay:2s]" viewBox="0 0 80 80" fill="none">
        <circle cx="40" cy="40" r="28" stroke="currentColor" strokeWidth="1.5" strokeDasharray="6 6" />
        <path d="M40 24v16l10 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>
  );
}

export function HeroBackdrop({ children, className = '' }) {
  return (
    <div className={`relative overflow-hidden ${className}`}>
      <GradientOrbs />
      <GridOverlay />
      <FloatingShapes />
      <div className="relative z-10">{children}</div>
    </div>
  );
}

export default HeroBackdrop;
